/* MAHA — sube el botón flotante de WhatsApp (.wa-float, ver sections/header.liquid
   + custom.css) cuando la barra sticky "Agregar" del PDP (.sticky-atc-bar, ver
   snippets/sticky-atc-bar.liquid) está visible, para que no se encimen en
   móvil/tablet (<1024px, la regla vive en custom.css). No toca el botón
   "Agregar" ni su comportamiento: solo lee la posición ya renderizada de la barra.

   2026-08-31 — DOBLE SALTO: fromBottom se calculaba con getBoundingClientRect(),
   que SÍ cambia mientras la barra hace su propia transición de aparición
   (transform/opacity/visibility, 0.3s -- ver section-sticky-atc-bar[-minimalist].css).
   Grabado cuadro a cuadro: al mostrarse la barra, el valor saltaba primero a un
   número viejo (el de la barra oculta) y ~300ms después, recién en transitionend,
   se corregía al valor final -- dos escrituras, dos saltos del botón. El alto de
   layout de la barra (offsetHeight) y su 'bottom' propio en CSS NO dependen de
   ese transform/opacity/visibility -- valen lo mismo oculta o mostrada -- así que
   dan el resultado FINAL de una vez, sin esperar a que la barra termine de
   deslizarse. Sigue sin asumir ningún alto fijo: se sigue midiendo en vivo, solo
   que con una medida que no cambia a medias de la animación. */
(function () {
  'use strict';
  if (window.__mahaWaFloatStickyOffsetInit) return;
  window.__mahaWaFloatStickyOffsetInit = true;

  function init() {
    var bar = document.querySelector('.sticky-atc-bar');
    var waFloat = document.querySelector('[data-wa-float]');
    if (!bar || !waFloat) return;

    function update() {
      var barBottom = parseFloat(getComputedStyle(bar).bottom) || 0;
      var fromBottom = Math.max(0, Math.round(bar.offsetHeight + barBottom));
      document.documentElement.style.setProperty('--wa-float-sticky-offset', fromBottom + 'px');
    }

    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    bar.addEventListener('transitionend', update);

    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(bar);
    }
    if (window.MutationObserver) {
      new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
